import { IRootState, IRootDispatch } from '@/store';

const user = {
  state: {
    username: '',
    menuTitle: '',
    headImage: '',
    studyTimeList: []
  },
  reducers: {
    update(prevState, payload) {
      return {
        ...prevState,
        ...payload,
      };
    },
  },

  effects: (dispatch: IRootDispatch) => ({
    async getUserInfo(payload, rootState: IRootState) {
      dispatch.user.update({
        menuTitle: '首页',
      });
    },
  }),
};

export default user;
